import Button, { Theme } from "theme/components/buttons/Button";

import React from "react";
import colors from "theme/config/colors";

const WhiteOutlinedButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        backgroundColor: "transparent",
        borderColor: colors.black,
        hover: {
            color: colors.black,
            backgroundColor: colors.white_30,
        },
        active: {
            color: colors.black,
            backgroundColor: colors.white_50,
        },
        selected: {
            color: colors.black,
            backgroundColor: "transparent",
            borderColor: colors.blue_700,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default WhiteOutlinedButton;
